<template lang="pug">
div.appRoot
	//- p Tu navegador no tiene JavaScript activado, pero este contenido se mostrará igualmente
	ClientOnly
		NuxtPage(:keepAlive="true")

	UiBarraSuperior
	UiModales
	UiNotificaciones
</template>

<script lang="ts" setup>
import { setConfigNotificaciones } from '@base/lib/notificaciones/config'

const ruta = useRoute()
useHead(armarHead(contextoApp, ruta.path))

// Configurar notificaciones lo antes posible (antes de cualquier llamada API)
setConfigNotificaciones({
  apiUrl: contextoApp.buildConfig.apiUrl,
  dispositivo: contextoApp.buildConfig.dispositivo,
  version: contextoApp.buildConfig.version
})

onMounted(() => {
	TemaOscuroAPI.init()
    TrosettaAPI.init()
})

</script>

<style lang="sass">
@use "@base/sass/comun"

.minhcomun
	min-height: 71dvh

header
	left: 0
	right: 0
	top: 0
	z-index: 10
	backdrop-filter: blur(6px)

html:not(.claro):not(.oscuro) header,
html.oscuro header
	background-color: rgba(0,0,0,.25)
html.claro header
	background-color: rgba(255,255,255,.25)


header
	.logoBoxmagic
		width: 3.81em
		height: 1em
		font-size: 4rem
	+comun.compu
		padding: 2rem 3rem
	+comun.movil
		padding: 1.5rem 2rem
		.logoBoxmagic
			font-size: 3.5rem
</style>


<style lang="sass" scoped>
html:not(.claro):not(.oscuro) .invisibleEnCarga
	visibility: hidden
	transition: all .3s ease .3s
.dev
	position: fixed
	top: 0
	left: 0
	margin: 1rem
	background-color: #333
	color: #999

// Modal
body.afectadoPorModal .appRoot
	touch-action: none
</style>
